import { HttpStatusCode } from "../types";

export class ApiResponse {
  constructor(
    public success: boolean,
    public httpStatusCode: HttpStatusCode,
    public body: any
  ) {}
}
